<template>
  <div id="app">
    <div class="container">
      <main>
        <div class="content">
          <div class="card fade-in">
            <h2 class="card-title">
              <i class="fas fa-building"></i> 砺兵职业技能学校
            </h2>
            <div class="company-info">
              <!-- <div class="company-image">
                <div>公司大楼</div>
              </div> -->
              <div class="company-details">
                <div class="mission">
                  <p class="intro-text">
                    砺兵职业技能培训学校是一所专注于军校报考辅导和国防教育的培训机构。
                    专家团队军校工作几十年，不仅熟悉军校招生政策、招生流程的每一个环节，
                    更了解全军院校的报考条件、体检标准、政审要求、报考流程和各院校的“地理位置、学科优势、办学条件、师资队伍、教学成果、招生专业、录取分数、学历待遇、学制年限、毕业分配”等。招生经验丰富，多年来成功助力大批学子踏入军校大门。辅导团队中有军校工作多年的校、部、系领导、专家教授、学员队干部组成。领导们高屋建瓴，把握军校整体发展方向;专家教授，能将复杂政策与专业知识通俗化并能结合军事实际，
                    让孩子一听就懂;院校办主任熟悉各项政策流程;学员队干部则深知学员成长路径，团队老师能为大家提供全方位指导。
                  </p>
                </div>

                <!-- 新增核心优势区域 -->
                <div class="core-advantages">
                  <div class="advantage-items">
                    <div class="advantage-item">
                      <span class="advantage-icon">🏆</span>
                      <div class="advantage-text">
                        <strong>强大</strong>
                        <br />专家团队
                      </div>
                    </div>
                    <div class="advantage-item">
                      <span class="advantage-icon">📚</span>
                      <div class="advantage-text">
                        <strong>权威</strong>
                        <br />录取数据
                      </div>
                    </div>
                    <div class="advantage-item">
                      <span class="advantage-icon">📊</span>
                      <div class="advantage-text">
                        <strong>专业</strong>
                        <br />测评系统
                      </div>
                    </div>
                    <div class="advantage-item">
                      <span class="advantage-icon">🛡️</span>
                      <div class="advantage-text">
                        <strong>可靠</strong>
                        <br />服务保障
                      </div>
                    </div>
                    <div class="advantage-item">
                      <span class="advantage-icon">🔍</span>
                      <div class="advantage-text">
                        <strong>全程</strong>
                        <br />录取跟踪
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { createApp } from "vue";
import ElementPlus from "element-plus";

// 滚动动画
onMounted(() => {
  const fadeElements = document.querySelectorAll(".fade-in");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.15 }
  );

  fadeElements.forEach((el) => {
    observer.observe(el);
  });
});
</script>

<style scoped>
/* 保持原有样式不变 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
}

:root {
  --primary: #4da8da;
  --primary-light: #e6f4ff;
  --secondary: #0077b6;
  --accent: #00b4d8;
  --light: #f8fbfe;
  --text: #1d3557;
  --text-light: #457b9d;
}

body {
  background: linear-gradient(135deg, #f0f9ff, #e1f5fe);
  color: var(--text);
  min-height: 100vh;
  padding: 10px 8px;
  background-attachment: fixed;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 10px 8px;
}

/* 头部样式 */
header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 0;
  position: relative;
  z-index: 2;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.logo {
  width: 130px;
  height: 130px;
  background: linear-gradient(135deg, var(--primary), var(--accent));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(77, 168, 218, 0.3);
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
}

.logo:hover {
  transform: scale(1.05);
  box-shadow: 0 15px 40px rgba(77, 168, 218, 0.4);
}

.logo::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
  transform: rotate(30deg);
}

.logo-text {
  font-size: 40px;
  font-weight: 800;
  color: white;
  letter-spacing: 2px;
}

h1 {
  font-size: 3.2rem;
  margin-bottom: 15px;
  color: var(--text);
  position: relative;
  display: inline-block;
}

h1::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  background: var(--accent);
  border-radius: 2px;
}

.tagline {
  font-size: 1.4rem;
  font-weight: 300;
  max-width: 700px;
  margin: 25px auto 0;
  color: var(--text-light);
  line-height: 1.6;
}

/* 内容区域 */
.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
  margin-top: 60px;
}

/* 卡片样式 */
.card {
  background: white;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 10px 20px rgba(29, 53, 87, 0.06);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: 1px solid rgba(77, 168, 218, 0.15);
}

.card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, var(--primary), var(--accent));
  z-index: 2;
}

.card-title {
  font-size: 1.6rem;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  color: var(--secondary);
}

.card-title i {
  margin-right: 12px;
  font-size: 1.5rem;
  color: var(--accent);
}

.company-info {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
}

.company-image {
  flex: 1;
  min-width: 300px;
  height: 350px;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 25px rgba(29, 53, 87, 0.15);
  background: linear-gradient(135deg, #b3e0ff, #80d0f7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.company-details {
  flex: 1;
  min-width: 300px;
}

.mission {
  line-height: 1.8;
  font-size: 1.1rem;
  color: var(--text);
  margin-bottom: 30px;
}

.mission p {
  margin-bottom: 20px;
}

.highlight {
  color: var(--secondary);
  font-weight: 600;
}

.foundation-date {
  display: flex;
  align-items: center;
  background: var(--primary-light);
  padding: 20px;
  border-radius: 15px;
  margin-top: 25px;
  border-left: 4px solid var(--accent);
}

.calendar-icon {
  font-size: 2.5rem;
  margin-right: 20px;
  color: var(--accent);
}

.date-content h3 {
  font-size: 1.1rem;
  margin-bottom: 5px;
  color: var(--text-light);
}

.date-content p {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--secondary);
}

/* 价值观部分 */
.values-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-top: 20px;
}

.value-card {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 5px 15px rgba(29, 53, 87, 0.05);
  transition: all 0.3s ease;
  border: 1px solid rgba(77, 168, 218, 0.1);
  text-align: center;
}

.value-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 25px rgba(77, 168, 218, 0.15);
}

.value-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: var(--primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 1.8rem;
  color: var(--accent);
}

.value-title {
  font-size: 1.3rem;
  margin-bottom: 15px;
  color: var(--secondary);
}

.value-description {
  color: var(--text-light);
  line-height: 1.6;
}

/* 动画效果 */
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(0px);
  }
}

.floating {
  animation: float 6s ease-in-out infinite;
}

.fade-in {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.fade-in.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 文段首行缩进 */
.intro-text {
  text-indent: 2em; /* 首行缩进两个汉字宽度 */
  line-height: 2;
}

/* 核心优势区域 ，五大图标，特点部分*/
.core-advantages {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.advantage-items {
  display: flex;
  gap: 15px;
  justify-content: space-around; /* 均匀分布每个项 */
  width: 100%; /* 确保父容器占满可用空间 */
}

.advantage-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 18%; /* 设置每个项的宽度 */
  min-width: 130px; /* 最小宽度防止过小 */
}

.advantage-item:hover {
  transform: translateY(-5px);
}

.advantage-icon {
  font-size: 36px; /* 增大图标尺寸 */
  color: #4caf50;
  margin-bottom: 10px;
}

.advantage-text {
  text-align: center;
  font-size: 18px; /* 增大文字尺寸 */
  color: #333;
}

.advantage-text strong {
  display: block;
  font-size: 24px; /* 增大标题尺寸 */
  margin-bottom: 5px;
}
</style>
